import { IconFile, mapper } from '@maia/icons';
import { TableCell } from '@maia/ui';
import { Link } from '@tanstack/react-router';
import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Claims } from './queryOptions';

type Claim = Claims['response'][number];

const columns: ColumnDef<Claim>[] = [
  {
    accessorKey: 'reference',
    header: 'Referentie',
    cell: ({ row }) => (
      <TableCell.Link
        to="/claims/$guid"
        params={{
          guid: row.original.guid,
        }}
      >
        {row.original.reference}
      </TableCell.Link>
    ),
  },
  {
    accessorKey: 'occurredAt',
    header: 'Schade datum',
    cell: ({ row }) => <TableCell.Date date={row.original.occurredAt} />,
  },
  {
    accessorKey: 'insurance',
    header: 'Product',
    enableSorting: false,
    cell: ({ row }) => (
      <TableCell.Product
        icon={mapper(row.original.insurance.icon)}
        title={row.original.insurance.title}
      />
    ),
  },
  {
    accessorKey: 'cause',
    header: 'Kenmerk',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Text text={row.original.cause} />,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Tag {...row.original.status} />,
  },
  //   {
  //     id: 'actions',
  //     cell: () => (
  //       <div className="flex gap-x-12 items-center">
  //         <ActionButton icon={IconSearchAlt} size="small" />
  //         <ActionButton icon={IconAngleRight} size="small" />
  //       </div>
  //     ),
  //   },
];

export function useClaimsTable(data?: Claims) {
  return useReactTable({
    columns,
    data: data?.response ?? [],
    rowCount: data?.response.length,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
}
